{
	"titlePage": "Conférence d'événements",
	"toThe": "au",
	"infoPage": "Lors du traitement d'un événement, il envoie les informations de facturation aux comptes à payer, comptes à recevoir, flux de trésorerie et DRE.",
	"viewDataConference": "Voir la conférence",
	"viewDataConferenceDetails": "Détails de la conférence",
	"dataActions": {
		"viewDetails": "Voir les détails",
		"eventProcess": "Traiter l'événement"
	},
	"tableColumns": {
		"date": "Date",
		"eventName": "Nom de l'événement",
		"totalIncome": "Revenu brut",
		"status": "Statut",
		"actions": "Actions",
		"dateAndTimeProccess": "Date et heure du traitement",
		"checkedBy": "Responsable du traitement"
	},
	"textPerStatus": {
		"loading": "Veuillez patienter, nous traitons les conférences",
		"success": "Toutes les conférences ont été traitées avec succès",
		"conclude": "Terminée"
	},
	"titleProcess": {
		"processing": "Traitement",
		"processed": "Traité",
		"processConferences": "Traiter les conférences"
	},
	"filter": {
		"searchName": {
			"title": "Rechercher des événements",
			"label": "Entrez le nom de l'événement"
		},
		"searchDate": {
			"title": "Période"
		},
		"searchStatus": {
			"title": "Afficher le statut"
		}
	},
	"buttonProcessMultiple": "Traiter les événements"
}
